namespace $.$$ {
	export class $shm_hitalama_map_widget_float_ai_request_mol_dom extends $.$shm_hitalama_map_widget_float_ai_request_mol_dom {
		
		prompt(): string {
			const text = this.$.$mol_fetch.text( $shm_hitalama_ghpages_fix_link( '/shm/hitalama/map/snippets/_prompt_mol_dom.md' ) )
			return text.replace( '{{Описание приложения}}', this.text() )
		}

		@ $mol_action
		set_obj( obj: any ) {
			this.Widget().widget().ai_request().obj( obj )
		}
		
		@ $mol_action
		paste() {

			const Widget = this.Widget()

			const text = $mol_wire_sync(navigator.clipboard).readText().replace(/\r\n/g, '\n').replace(/\r/g, '\n')
			let obj = parse_code(text) as AI_answer

			const parent_id = Widget.widget().ai_request().parent_id()
			if( parent_id ) {
				const parent = $giper_baza_glob.Pawn( new $giper_baza_link( parent_id ), $shm_hitalama_map_widget )
				const parent_data = parent.ai_request().obj() as AI_answer
				obj = {
					Model: { ...parent_data.Model, ...obj.Model??{} },
					View: { ...parent_data.View, ...obj.View??{} },
					Css: { ...parent_data.Css, ...obj.Css??{} },
				}
			}
			this.set_obj( obj )

			const css = create_css( Widget.widget().link_str(), obj.Css )

			const code = 'class Model {\n' +
				Object.entries( obj.Model ).map( v => 
					`\t${v[1][0] ? '@ '+v[1][0]+' ':''}${v[0]}(${v[1][1]}) `
					+ `{\n${v[1][2]}\n\t}\n`
				).join('\n')
			+ '}\n\nclass View extends $shm_hitalama_map_widget_float_ai_request_mol_dom_base {\n' +
				Object.entries( obj.View ).map( v => 
					`\t${v[1][0] ? '@ '+v[1][0]+' ':''}${v[0]}(${v[1][1]}) `
					+ `{\n${v[1][2]}\n\t}\n`
				).join('\n')
			+ `}\n`
			+ `\nconst css = \`${css}\``
			+ `\n$mol_style_attach( '${Widget.widget().link_str()}', css )\n`
			+ `\nconst root = (new View).root()`
			+ `\nconst wrapper = document.createElement('div')`
			+ `\nwrapper.appendChild(root)`
			+ `\nwrapper.style.all = 'initial'`
			+ `\nwrapper.style.zIndex = '1'`
			+ `\nwrapper.style.backgroundColor = 'white'`
			+ `\nwrapper.setAttribute('data-crus-ref', '${Widget.widget().link_str()}')\nreturn wrapper`

			const gap = 25
			const x = Widget.left()// + Widget.width() + 10
			const y = Widget.top() + Widget.height() + gap

			const app_height = 600
			const app_widget = Widget.map().widget_add( 'customdom', [x, y], 600, app_height )
			app_widget?.text(code)

			const code_widget = Widget.map().widget_add( 'code', [ x, y + app_height ], 600, 1000 )
			code_widget?.Use_text_from(null)?.remote( app_widget )

		}
		
	}

	type AI_answer = {
		Model: Record< string, string[] >,
		View: Record< string, string[] >,
		Css: Record< string, string >,
	}
	
	function create_css( ref: string, css_selectors: AI_answer[ 'Css' ] ): string {
		const cssRules: string[] = []
		for( const sel in css_selectors ) {
			cssRules.push( `[data-crus-ref="${ref}"] ${ sel.trim() } { ${ css_selectors[sel].trim() } }` )
		}
		return cssRules.join( '\n' )
	}

	export class $shm_hitalama_map_widget_float_ai_request_mol_dom_base {
		createElement( tag: string, key: string ) {
			const el = document.createElement( tag )
			el.id = key
			el.className = key.split('/')[0]
			return el
		}
		@ $mol_mem_key div(key: string) { return this.createElement( 'div', key ) }
		@ $mol_mem_key span(key: string) { return this.createElement( 'span', key ) }
		@ $mol_mem_key img(key: string) { return this.createElement( 'img', key ) }
		@ $mol_mem_key input(key: string) { return this.createElement( 'input', key ) }
		@ $mol_mem_key h1(key: string) { return this.createElement( 'h1', key ) }
		@ $mol_mem_key h2(key: string) { return this.createElement( 'h2', key ) }
		@ $mol_mem_key h3(key: string) { return this.createElement( 'h3', key ) }
		@ $mol_mem_key h4(key: string) { return this.createElement( 'h4', key ) }
		@ $mol_mem_key h5(key: string) { return this.createElement( 'h5', key ) }
		@ $mol_mem_key h6(key: string) { return this.createElement( 'h6', key ) }
		@ $mol_mem_key p(key: string) { return this.createElement( 'p', key ) }
		@ $mol_mem_key a(key: string) { return this.createElement( 'a', key ) }
		@ $mol_mem_key button(key: string) { return this.createElement( 'button', key ) }
		@ $mol_mem_key textarea(key: string) { return this.createElement( 'textarea', key ) }
		@ $mol_mem_key select(key: string) { return this.createElement( 'select', key ) }
		@ $mol_mem_key option(key: string) { return this.createElement( 'option', key ) }
		@ $mol_mem_key label(key: string) { return this.createElement( 'label', key ) }
		@ $mol_mem_key table(key: string) { return this.createElement( 'table', key ) }
		@ $mol_mem_key thead(key: string) { return this.createElement( 'thead', key ) }
		@ $mol_mem_key tbody(key: string) { return this.createElement( 'tbody', key ) }
		@ $mol_mem_key tfoot(key: string) { return this.createElement( 'tfoot', key ) }
		@ $mol_mem_key tr(key: string) { return this.createElement( 'tr', key ) }
		@ $mol_mem_key th(key: string) { return this.createElement( 'th', key ) }
		@ $mol_mem_key td(key: string) { return this.createElement( 'td', key ) }
		@ $mol_mem_key video(key: string) { return this.createElement( 'video', key ) }
		@ $mol_mem_key audio(key: string) { return this.createElement( 'audio', key ) }
		@ $mol_mem_key progress(key: string) { return this.createElement( 'progress', key ) }
		@ $mol_mem_key canvas(key: string) { return this.createElement( 'canvas', key ) }
		@ $mol_mem_key svg(key: string) { return this.createElement( 'svg', key ) }
	}

	function parse_code( code: string ) {
		const result = {
			Model: {} as Record<string, string[]>,
			View: {} as Record<string, string[]>,
			Css: {} as Record<string, string>
		}

		const lines = code.split( '\n' )
		let currentClass = ''
		let currentMethod = ''
		let methodBody: string[] = []
		let collectingBody = false
		let decorator = ''
		let params = ''
		let bracketCount = 0

		const methodRegex = /^(\s{4}|\t)(\w+)\(([^)]*)\)\s*\{.*$/
		const decoratorRegex = /^(\s{4}|\t)@\s*([\w_$]+(?:\.[\w_$]+)*)\s*$/

		let currentKeyCss: string | null = null
		let currentValueCss: string[] = []
		let inMultilineStringCss = false

		for( let i = 0; i < lines.length; i++ ) {
			let line = lines[ i ]

			if( line.includes( 'class Model ' ) ) {
				currentClass = 'Model'
				continue
			} else if( line.includes( 'class View ' ) ) {
				currentClass = 'View'
				continue
			} else if( line.includes( 'const Css = {' ) ) {
				currentClass = 'Css'
				continue
			}

			if( currentClass === 'Css' ) {
				line = line.trim()

				if( !inMultilineStringCss ) {
					const keyMatch = line.match( /^"([^"]+)"\s*:\s*/ )
					if( keyMatch ) {
						if( currentKeyCss && currentValueCss.length > 0 ) {
							result.Css[ currentKeyCss ] = currentValueCss.join( '\n' )
						}

						currentKeyCss = keyMatch[ 1 ]
						currentValueCss = []

						const restOfLine = line.slice( keyMatch[ 0 ].length )

						const multilineMatch = restOfLine.match( /^`/ )
						if( multilineMatch ) {
							inMultilineStringCss = true
							if( !restOfLine.includes( '`', 1 ) ) {
								const content = restOfLine.slice( 1 )
								if( content ) {
									currentValueCss.push( content )
								}
								continue
							}
						}

						const stringMatch = restOfLine.match( /^"([^"]*)"\s*,?\s*$/ )
						if( stringMatch ) {
							result.Css[ currentKeyCss ] = stringMatch[ 1 ]
							currentKeyCss = null
							continue
						}
					}
				}

				if( inMultilineStringCss ) {
					const closeIndex = line.indexOf( '`' )
					if( closeIndex !== -1 ) {
						const content = line.substring( 0, closeIndex )
						if( content ) {
							currentValueCss.push( content )
						}

						if( currentKeyCss ) {
							result.Css[ currentKeyCss ] = currentValueCss.join( '\n' )
						}

						currentKeyCss = null
						currentValueCss = []
						inMultilineStringCss = false
					} else {
						currentValueCss.push( line )
					}
				}
				continue
			}

			if( !currentClass ) continue

			const decoratorMatch = line.match( decoratorRegex )
			if( decoratorMatch ) {
				decorator = decoratorMatch[ 2 ].trim()
				continue
			}

			console.log('line', line)
			const methodMatch = line.match( methodRegex )
			console.log('methodMatch', methodMatch)
			if( methodMatch && ( line.includes( '{' ) ) ) {
				currentMethod = methodMatch[ 2 ]
				params = methodMatch[ 3 ] || ''
				collectingBody = true
				methodBody = []
				bracketCount = 1
				// methodBody.push(line)
				continue
			}

			if( collectingBody && currentMethod ) {
				for( const char of line ) {
					if( char === '{' ) bracketCount++
					if( char === '}' ) bracketCount--
				}

				methodBody.push( line )

				if( bracketCount === 0 ) {
					( result as any )[ currentClass ][ currentMethod ] = [
						decorator || '',
						params,
						methodBody.slice( 0, -1 ).join( '\n' )
					]
					collectingBody = false
					currentMethod = ''
					decorator = ''
					params = ''
					methodBody = []
				}
			}
		}

		if( currentKeyCss && currentValueCss.length > 0 ) {
			result.Css[ currentKeyCss ] = currentValueCss.join( '\n' )
		}

		return result
	}


}
